// extracted by mini-css-extract-plugin
export default {"page":"XX-z","cartModal":"YX-z","checkout":"ZX-z","placeholder":"_X-z","account":"aY-z"};